module.exports = __webpack_public_path__ + "img/1 (122).6522b8b5.png";